export const FORMNAMES = {
    SCHOOLPROFILE: "school_profile",
    SCHOOLBANNERS: "school_banners",
    SCHOOLINFRASTUCTURE: "school_infrastructure",
    SCHOOLAPPROACH: "school_approach",
    SCHOOLDIGNATORIES: "school_dignitaries",
    SCHOOLFEATURES: "school_features",
    SCHOOLGALLERY: "school_gallery",
    STUDENTS: "student_information",
    TOPPER_STUDENTS: "top_students",
    STAFFINFORMATION: "staff_information"
}
